import React, { ReactNode } from 'react';

import { defineMessage, useIntl } from 'react-intl';

import { NavPlatformSideNav } from '@townsquare/nav-platform-integration/NavPlatformSideNav';

import { useRovoSideNavItems } from '../sidebar/use-rovo-side-nav-items';
import { useSideNavAppItemsForNavPlatform } from '../sidebar/use-side-nav-app-items-for-nav-platform';

import { useForYouConfig } from './use-for-you-config';

const rovoAppLabelMessage = defineMessage({
	id: 'townsquare.rovo.app.label',
	defaultMessage: 'Rovo',
	description: 'Label for the Rovo app when shown in the global side navigation.',
});

type Props = {
	/**
	 * An optional component that would appear under the main nav items but before the app shortcuts and More/Customize
	 * menu.
	 * Passed in to GlobalSideNavigation as the `postItemsElem` prop.
	 */
	postItemsElem?: ReactNode;
};

export function RovoAppSideNav({ postItemsElem }: Props): React.JSX.Element {
	const sidebarItems = useRovoSideNavItems();
	const appShortcuts = useSideNavAppItemsForNavPlatform();
	const { formatMessage } = useIntl();

	const forYouConfig = useForYouConfig();

	return (
		<NavPlatformSideNav
			app="home"
			appLabel={formatMessage(rovoAppLabelMessage)}
			appItems={sidebarItems}
			appShortcuts={appShortcuts}
			disableMenuCustomization
			forYou={forYouConfig}
			postItemsElem={postItemsElem}
		/>
	);
}
